import {type RpcResponder} from './types';

const BRAND: unique symbol = Symbol();
export type Responder<state, action> = {[BRAND]: state & action};

export const mkResponder = <state, action, req, res, context>(
  r: RpcResponder<state, action, req, res, context>
): Responder<state, action> => r as never;

export const runResponder =
  <state, action, out, context>(
    f: <req, res>(rr: RpcResponder<state, action, req, res, context>) => out
  ) =>
  (r: Responder<state, action>): out =>
    f(r as never);
